var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7042 7.37414C19.5109 7.61223 14.8751 13.1472 10.0264 13.1472C5.17761 13.1472 0.491336 7.61223 0.295258 7.37694C0.110384 7.15845 0.110384 6.83912 0.292456 6.61784L0.295199 6.61459C0.530487 6.3361 5.16998 0.844727 10.0011 0.844727C14.8527 0.844727 19.5081 6.38254 19.7042 6.61784C19.8863 6.83632 19.8863 7.15565 19.7042 7.37414ZM10.0264 11.954C13.6286 11.954 17.3261 8.21728 18.4353 6.99879C17.3205 5.7803 13.6006 2.038 10.0011 2.038C6.3989 2.038 2.68181 5.7747 1.56697 6.99599C2.69022 8.21447 6.42691 11.954 10.0264 11.954ZM12.4829 7.08002C12.4829 4.82792 10.5894 4.63744 10.102 4.62624C10.032 4.62344 9.94512 4.62344 9.86949 4.62344C9.36809 4.62624 7.51655 4.79431 7.51655 7.06602C7.51655 9.34052 9.38769 9.517 9.88629 9.5254C9.96192 9.5254 10.0376 9.5254 10.1132 9.5226C10.5866 9.51419 12.4829 9.33772 12.4829 7.08002Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEye);
export default __webpack_public_path__ + "static/media/icon-eye.3f2613b073ff41701bf55c9ff2fce865.svg";
export { ForwardRef as ReactComponent };